import {ActionableError} from './base/actionable-error'
import {NonActionableError} from './base/non-actionable-error'

export class ClientNetworkError extends NonActionableError {
  constructor(
    err: string,
    public cause: TypeError
  ) {
    super(err)
    this.name = 'ClientNetworkError'
  }
}

export class ClientMalformedRequestError extends ActionableError {
  constructor(
    err: string,
    public cause: TypeError
  ) {
    super(err)
    this.name = 'ClientMalformedRequestError'
  }
}

export class ClientRequestAbortError extends NonActionableError {
  constructor(
    err: string,
    public cause: Error
  ) {
    super(err)
    this.name = 'ClientRequestAbortError'
  }
}
